import { refreshFolders } from '.';
import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { notify } from '../../actions/notifications';
import { setSharedCollectionName } from '../../actions/shareCollection';
import {
  fetchWebUpdateFolder,
  TWebUpdateFolderRequest,
  TWebUpdateFolderResponse,
} from '../../repositories/favorites/v1/web/update-folder';
import { ENotificationStyle } from '../../types/notifications';
import { TThunkAction } from '../../types/redux';

export const updateFolder =
  (parameters: TWebUpdateFolderRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const showError = () => dispatch(notify('Не удалось переименовать подборку', ENotificationStyle.Error));

    try {
      const { statusCode, response }: TWebUpdateFolderResponse = await fetchWebUpdateFolder({ httpApi, parameters });

      if (statusCode === 200) {
        dispatch(fetchFavoriteEntities({ offset: 0 }));
        dispatch(refreshFolders());
        dispatch(setSharedCollectionName({ id: parameters.id, value: parameters.name }));
      }

      if (statusCode === 400) {
        showError();
        logger.warning(response.message || 'Fail to update folder');
      }
    } catch (e) {
      showError();
      logger.error(e, {
        description: 'Fail to update folder',
      });
    }
  };
